import React, { FC, useMemo } from 'react'
import { makeStyles } from '@material-ui/core'
import { CellItem } from '@components/UI-Components/HierarchyWiseItemsTable/components/Row/Cell'
import { useObserver } from 'mobx-react-lite'
import useViewContext from '@modules/order/hooks/use-view-context'
import useOrderContext from '@modules/order/hooks/use-order-context'
import { isCaptureSizeEnabled } from '@modules/order/utils/table-column-utils'
import { InitialAllocationUIStore } from '@modules/showroom/EnhancedOrder/stores/EnhancedListView/InitialAllocationUIStore'
import { InitialAllocationDataStore } from '@modules/showroom/EnhancedOrder/stores/EnhancedListView/InitialAllocationDataStore'
import IAWarehouseSizeQuantities from './IAWarehouseSizeQuantities'

const useStyles = makeStyles(theme => ({
  IAWarehouseQuantitiesCellRoot: {
    width: '100%'
  },
  firstCellPartition: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    height: 65,
    borderBottom: '1px solid #eeeeee'
  },
  secondCellPartition: {
    width: '100%',
    height: 65,
    padding: '10px 10px 10px 10px',
    textAlign: 'center',
    borderBottom: '1px solid #eeeeee'
  },
  thirdCellPartition: {
    width: '100%',
    height: 105,
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    padding: '10px 10px 10px 10px',
    borderBottom: '1px solid #EEEEEE',
    background: theme.palette.background.default
  }
}))

const IAWarehouseQuantitiesCell: FC<CellItem> = ({ rowData }) =>
  useObserver(function useHook() {
    const classes = useStyles()
    const { uiStore } = useViewContext()
    const {
      uiStore: {
        dataStore: { summary }
      }
    } = useOrderContext()
    const {
      getSizes,
      showProductSizes,
      dataStore: { getIAProductData }
    } = uiStore as InitialAllocationUIStore<InitialAllocationDataStore>
    const productRowId = rowData?.id
    const IAProductData = getIAProductData(productRowId) || {}
    const hasCaptureSize = isCaptureSizeEnabled(summary)
    const sizesList: any = useMemo(
      () =>
        rowData && hasCaptureSize && showProductSizes[productRowId]
          ? getSizes(productRowId)
          : [],
      [getSizes, hasCaptureSize, productRowId, showProductSizes]
    )

    if (!rowData) return <></>

    return (
      <div
        className={classes.IAWarehouseQuantitiesCellRoot}
        data-testid='IAWarehouseQuantitiesCell'
      >
        <div className={classes.firstCellPartition}></div>
        <div className={classes.secondCellPartition}></div>
        <div className={classes.thirdCellPartition}></div>
        <IAWarehouseSizeQuantities
          showProductSizes={showProductSizes[productRowId]}
          hasCaptureSize={hasCaptureSize}
          sizesList={sizesList}
          deliveryWarehouseSizeQuantity={
            IAProductData?.deliveryWarehouseSizeQuantity || 0
          }
          deliveryWarehouseSizeQuantities={
            IAProductData?.deliveryWarehouseSizeQuantities || {}
          }
        />
      </div>
    )
  })

export default IAWarehouseQuantitiesCell
